import { UserState } from "./user-state.interface";
import { IUser } from "../../../../types/user/iuser.interface";

export function createUserState(): UserState {
  return {
    loading: false,
    profile: {} as IUser,
  };
}
